
import styled from 'styled-components';
import Label from '../../element/ui/core/label';

const StyledToolsBar = styled.div`
  padding: 0 1px 0;
  width: fit-content;
  margin: 0 auto;
  max-width: 99.5%;
  max-height: 92px;

  [data-phone='true'] & {
    padding: 0;
    margin-top: 8px;
    max-height: initial;
  }
`;

const StyledToolsBarItems = styled.div`
  display: flex;
  align-items: center;
  overflow-x: auto;
  [data-phone='true'] & {
    background: ${({ theme }) => theme.palette['bg-primary']};
  }
`;

const StyledToolsBarItemButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  box-sizing: border-box;

  .respark_draw-tools-strip & {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
  }

  &,
  * {
    cursor: pointer;
  }
`;

const StyledToolsBarItemButtonLabel = styled(Label)`
  margin-left: 6px;

  .respark_draw-tools-strip & {
    margin-left: 0;
    width: 100%;
    text-align: center;
  }
`;

const StyledToolsBarItemOptionsWrapper = styled.div`
  position: relative;
  width: 100%;
  transition: all 100ms ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0;

  ${(props) => `
      max-height: ${props.hasChildren ? 'none' : 0};
      overflow: ${props.hasChildren ? 'visible' : 'hidden'};
      margin: ${props.hasChildren ? '0 auto 8px' : 0};
    `};
`;

export {
  StyledToolsBar,
  StyledToolsBarItems,
  StyledToolsBarItemButton,
  StyledToolsBarItemButtonLabel,
  StyledToolsBarItemOptionsWrapper,
};
